
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoraigharfortcabservice() {



    const cardData =
    {
        keyword: 'Pune to Raigad Fort Cab Services',
        heading: 'S9 Travels: Pune to Raigad Fort Cab Services',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable cab services from Pune to Raigad Fort. Whether you are a history enthusiast or a nature lover, Raigad Fort is the perfect destination. Situated approximately 170 km from Pune, the journey takes about 4 to 5 hours by road. Travel with S9 Travels for a smooth and enjoyable ride, as our professional drivers ensure a safe and hassle-free experience with well-maintained cabs and customer-centric services.',

        top: 'Top Places to Visit in Raigad with S9 Travels',

  "topPlaces": [
    {
      "title": "Raigad Fort",
      "description": "Raigad Fort is a historic fort that holds immense significance as the capital of the Maratha Empire under Chhatrapati Shivaji Maharaj. The fort offers stunning views of the surrounding valleys and hills and showcases impressive architecture, including the King’s Palace, Queen’s Quarters, and the famous Raigad Fort Shivaji Statue."
    },
    {
      "title": "Shivaji Maharaj's Statue",
      "description": "The massive statue of Chhatrapati Shivaji Maharaj at Raigad Fort stands tall and majestic, symbolizing the courage and leadership of the great Maratha king. The statue is one of the key highlights of the fort and is a must-see for visitors."
    },
    {
      "title": "Raigad Ropeway",
      "description": "The Raigad Ropeway offers an exciting and scenic ride up to Raigad Fort, providing breathtaking views of the surrounding landscapes and lush greenery. The ropeway makes it easier for visitors to reach the fort, especially those who want to skip the trek."
    },
    {
      "title": "Jagadishwar Temple",
      "description": "Jagadishwar Temple is an ancient temple dedicated to Lord Shiva, located within the Raigad Fort. It is an important pilgrimage site for devotees and provides a peaceful atmosphere amidst the fort’s historical surroundings."
    },
    {
      "title": "Takmak Point",
      "description": "Takmak Point is a scenic viewpoint on Raigad Hill that offers panoramic views of the valleys and hills below. It is also historically significant, as it is believed to have been the execution site of criminals during the Maratha rule."
    },
    {
      "title": "Mena Darwaza",
      "description": "Mena Darwaza is the main entrance to the Raigad Fort, which once led directly to the royal quarters. The architecture and design of the gate are awe-inspiring, showcasing the fort’s grandeur and the strategic planning of its design."
    },
    {
      "title": "Bastion and Watch Towers",
      "description": "Raigad Fort has several bastions and watchtowers that offer strategic views of the surrounding area. These structures were used for defense purposes during the fort’s active years and now serve as intriguing points of interest for visitors interested in history."
    },
    {
      "title": "Ganga Sagar Lake",
      "description": "Ganga Sagar Lake is located at the base of Raigad Fort, surrounded by lush greenery. The lake offers a tranquil environment and is perfect for nature walks or a peaceful break after exploring the fort."
    },
    {
      "title": "Raigad Fort Marketplace (Bazaar)",
      "description": "The marketplace at Raigad Fort was once a bustling hub for trade and commerce. Today, it offers visitors a glimpse into the fort’s past, showcasing the life of people who once lived and worked on the fort during its prime."
    }
],

       "services": [
    {
      "name": "Book Pune to Raigad Fort Taxi",
      "description": "S9 Travels offers comfortable and reliable taxi services from Pune to Raigad Fort. Whether you are visiting for a historical tour or a scenic getaway, we ensure a smooth and memorable journey."
    },
    {
      "name": "Book Pune to Raigad Fort Cab Service",
      "description": "Book your Pune to Raigad Fort cab with S9 Travels for a convenient and hassle-free ride. Our well-maintained vehicles and professional drivers ensure you have a comfortable experience throughout your trip."
    },
    {
      "name": "Pune to Raigad Fort One-Way Taxi",
      "description": "Enjoy a direct and efficient ride with our one-way taxi service from Pune to Raigad Fort. S9 Travels offers cost-effective one-way taxi services, making your trip simpler and more affordable."
    },
    {
      "name": "Pune to Raigad Fort Round Trip",
      "description": "S9 Travels offers round-trip taxi services from Pune to Raigad Fort. Experience a comfortable ride to and from the fort with our professional drivers who ensure punctuality and comfort."
    },
    {
      "name": "Pune to Raigad Fort Taxi Fare",
      "description": "We provide transparent and affordable taxi fares for your journey to Raigad Fort. At S9 Travels, there are no hidden charges, giving you peace of mind as you plan your trip."
    },
    {
      "name": "Pune to Raigad Fort Car Rental",
      "description": "S9 Travels offers car rental services for your trip to Raigad Fort. Choose from a variety of vehicles that cater to your needs, ensuring a flexible and comfortable travel experience."
    },
    {
      "name": "Pune to Raigad Fort Luxury Taxi",
      "description": "For a premium experience, book a luxury taxi from Pune to Raigad Fort with S9 Travels. Enjoy extra comfort, ample space, and a smooth journey, making your visit to the fort even more special."
    },
    {
      "name": "Pune to Raigad Fort Efficient Taxi",
      "description": "Traveling on a budget? S9 Travels offers Efficient Taxi services from Pune to Raigad Fort. Share the ride with others while enjoying a comfortable and cost-effective trip to the fort."
    },
    {
      "name": "Raigad Fort Taxi Service",
      "description": "S9 Travels provides reliable Raigad Fort taxi services from Pune. Whether for a historical tour or a road trip, our drivers will ensure that you have a smooth and enjoyable ride to one of Maharashtra’s most iconic forts."
    },
    {
      "name": "Raigad Fort Private Cab from Pune",
      "description": "For a personalized experience, book a private cab from Pune to Raigad Fort with S9 Travels. Travel at your own pace with the privacy and comfort of a dedicated vehicle and driver."
    },
    {
      "name": "Affordable Raigad Fort Cab",
      "description": "S9 Travels offers affordable cab services for your journey from Pune to Raigad Fort. We ensure that you can visit this historic site without compromising on comfort or breaking your budget."
    },
    {
      "name": "Group Travel to Raigad Fort",
      "description": "Planning to visit Raigad Fort with a group? S9 Travels provides group travel taxi services from Pune to Raigad Fort, ensuring everyone enjoys a comfortable journey to the fort together."
    },
    {
      "name": "Raigad Fort Sightseeing Tour",
      "description": "Experience a Raigad Fort sightseeing tour with S9 Travels. Our professional drivers will ensure you get the most out of your visit, guiding you to the fort's key historical spots and helping you enjoy your tour to the fullest."
    },
    {
      "name": "Raigad Fort Trip Taxi",
      "description": "Book your Raigad Fort trip taxi with S9 Travels for a convenient and comfortable ride. We ensure you travel in style while discovering the beauty and history of this remarkable fort."
    },
    {
      "name": "Raigad Fort Road Trip from Pune",
      "description": "Take a scenic road trip from Pune to Raigad Fort with S9 Travels. Our comfortable and safe vehicles, along with experienced drivers, make your road trip a delightful experience."
    }
],

"tableData": [
  ["Book Pune To Raigad Fort Taxi", "Book Pune To Raigad Fort Cab Service"],
  ["Book Pune To Raigad Fort One-Way Taxi", "Book Pune To Raigad Fort Round Trip"],
  ["Book Pune To Raigad Fort Taxi Fare", "Book Pune To Raigad Fort Car Rental"],
  ["Book Pune To Raigad Fort Luxury Taxi", "Book Pune To Raigad Fort Efficient Taxi"],
  ["Raigad Fort Taxi Service", "Raigad Fort Private Cab from Pune"],
  ["Affordable Raigad Fort Cab", "Group Travel to Raigad Fort"],
  ["Raigad Fort Sightseeing Tour", "Raigad Fort Trip Taxi"],
  ["Raigad Fort Road Trip from Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time when planning a visit to the historical Raigad Fort. Our drivers ensure timely pickups and drop-offs, so you can enjoy your journey without delays and have a stress-free trip to this iconic fort."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars for your trip to Raigad Fort. Our vehicles are equipped with spacious interiors, air conditioning, and ample luggage space to ensure a comfortable and enjoyable ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, professional, and familiar with the best routes to Raigad Fort. They ensure a smooth, safe, and comfortable journey, allowing you to focus on the historical significance and scenic beauty of the fort."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Raigad Fort trip. We provide a clear breakdown of costs with no hidden charges, ensuring that you know exactly what to expect and can plan your trip without any worries."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride to Raigad Fort. Enjoy your journey with peace of mind knowing we have taken every measure to keep you safe."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night return, S9 Travels operates round the clock to meet your needs. Our customer service team is available at all hours to assist with bookings, queries, or any other requirements."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Raigad Fort journey is simple and convenient with S9 Travels. You can easily book through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you are visiting Raigad Fort for history, adventure, or relaxation, we offer customized travel packages that fit your needs. Let us know your preferences, and we’ll tailor your trip to make it special and memorable."
  }
]



















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Raigad Fort cab with S9 Travels?',
            answer: 'Booking a cab is easy! You can book online through our website or app, or you can contact our customer service team for personalized assistance and guidance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Raigad Fort trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to ensure a comfortable and safe journey.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Raigad Fort?',
            answer: 'Yes, all our drivers are experienced in driving long distances and are familiar with the best routes to Raigad Fort. They ensure a safe and enjoyable trip.',
          },
          {
            question: 'How do I pay for my Pune to Raigad Fort cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Raigad Fort?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey from Raigad Fort.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing at Raigad Fort?',
            answer: 'Yes, we offer sightseeing services around Raigad Fort. Explore the fort’s history, scenic views, and nearby attractions with the assistance of our knowledgeable drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Raigad Fort cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Raigad Fort?',
            answer: 'Yes, we offer corporate and group travel services to Raigad Fort. Whether it\'s for a corporate outing or a group of friends or family, we ensure a safe and enjoyable journey for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Raigad Fort journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Raigad Fort.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sameer Kulkarni',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for a trip to Raigad Fort. The vehicle was clean and comfortable, and the driver was very professional. We had a smooth journey, and the historical insights provided by the driver made the trip even more enjoyable. Highly recommend!”',
        },
        {
          name: 'Mrs. Neha Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family trip to Raigad Fort was fantastic, thanks to S9 Travels. The vehicle was spacious, and the driver was very polite and knowledgeable. We had a comfortable ride and enjoyed exploring the fort. Will definitely book again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Raigad Fort Cab Service",
        "description": "Book Pune to Raigad Fort cab services with S9 Travels. Whether you're looking for a one-way taxi, round-trip, luxury taxi, or car rental, we offer affordable and reliable transport to Raigad Fort. Book private cabs, Efficient Taxis, or plan a sightseeing tour and road trip to Raigad Fort for an unforgettable experience from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      
      


    return (
        <div>
         <Helmet>
        <title>Pune To Raigad Fort Cab Service | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Raigad Fort taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your Raigad Fort sightseeing tour, private cab bookings, group travel, and road trip from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoraigharfortcabservice;